import {  useContext } from "react";
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from "../shared/context/auth-context";

const ProtectedRoute = ({ component: Component, requiredRole, ...rest }) => {
    const { isLoggedIn, role } = useContext(AuthContext);

    return (
        <Route
            {...rest}
            render={props => 
                isLoggedIn && (requiredRole ? role === requiredRole : true ) ? (
                    <Component {...props}/>
                ) : (
                    <Redirect to='/' />
                )
            }
        />
    )
}
export default ProtectedRoute;